import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type QualityIncidentsType = {
  qualityIncidentsData: TableData;
};

const { qualityIncidentsColumns } = TABLE_COLUMNS;

const initialState: QualityIncidentsType = {
  qualityIncidentsData: {
    columns: qualityIncidentsColumns,
    rows: [],
  },
};

const qualityIncidentsSlice = createSlice({
  name: 'qualityIncidents',
  initialState,
  reducers: {},
});

export const {} = qualityIncidentsSlice.actions;
export const selectQualityIncidents = (state) => state.qualityIncidents;
export const qualityIncidentsReducer = qualityIncidentsSlice.reducer;
